// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 625 ? "imagePhotoswipe" : chunkId) + "." + {"359":"ff683b1f","625":"588017e1"}[chunkId] + ".js";
};